import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import config from 'config';
import {register as registerApi, verifyToken} from '../../services/user/api';
import {handleChange} from '../../utils/ComponentUtilFunctions';
import BlueButton from "../../components-new/buttons/BlueButton";
import SilverButton from "../../components-new/buttons/SilverButton";
import {Link} from "react-router-dom";
import Input from "../../components-new/form/Input";

class Registration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            firstName: '',
            lastName: '',
            password: '',
            contactNumber: '',
            confirmPassword: '',
            thumbUrl: '',
            uploadingIcon: false,
            uploadPercent: 0,
            disabled: false,
        };
        this.onUploadProgress = this.onUploadProgress.bind(this);
        this.handleChange = handleChange.bind(this);
    }

    componentDidMount() {
        const {addNotification, token} = this.props;

        verifyToken(token).then(() => {
            addNotification('yourTokenIsValid', config.notificationLevels.success);
        }).catch(() => {
            addNotification('yourTokenIsInvalid', config.notificationLevels.error, {
                autoDismiss: 0,
            });
            setTimeout(() => {
                window.location.href = config.APP_HOST + "/login";
            }, 1000);
        });
    }

    onUploadProgress(progressEvent) {
        this.setState({
            uploadPercent: Math.round((progressEvent.loaded * 100) / progressEvent.total),
        });
    }

    register = (event) => {
        event.preventDefault();
        const {
            username, firstName, lastName, contactNumber, password, confirmPassword, thumbUrl, disabled,
        } = this.state;

        if (disabled) {
            return;
        }

        const {addNotification, token} = this.props;

        this.setState({
            disabled: true,
        });
        registerApi({
            username,
            firstName,
            lastName,
            contactNumber,
            thumbUrl,
            password,
            confirmPassword
        }, token)
            .then(() => {
                window.location.href = config.APP_HOST + '/login';
            })
            .catch((e) => {
                this.setState({disabled: false});
                if (e.response && e.response.data === "") {
                    addNotification('somethingWentWrong', config.notificationLevels.error);
                } else {
                    addNotification(e.response.data, config.notificationLevels.error);
                }
            });
    };

    handlePasswordChange = (event) => {
        const value = event.target.value;
        this.setState({password: value});
    };

    handleConfirmPasswordChange = (event) => {
        const value = event.target.value;
        this.setState({confirmPassword: value});
    };

    render() {
        const {
            username,
            firstName,
            lastName,
            contactNumber,
            password,
            confirmPassword,
        } = this.state;

        return (
            <div>

                <h1 className="form-header">
                    Registration
                </h1>

                <div className="app-login-form">
                    <form className="auth-form" onSubmit={this.register}>

                        <Input
                            type="text"
                            value={username}
                            onChange={this.handleChange('username')}
                            placeholder={'Username *'}
                        />

                        <Input
                            type="text"
                            value={firstName}
                            onChange={this.handleChange('firstName')}
                            placeholder={'First name *'}
                        />

                        <Input
                            type="text"
                            value={lastName}
                            onChange={this.handleChange('lastName')}
                            placeholder={'Last name *'}
                        />

                        <Input
                            type="text"
                            value={contactNumber}
                            onChange={this.handleChange('contactNumber')}
                            placeholder={'Phone number'}
                        />

                        <Input
                            type="password"
                            value={password}
                            onChange={this.handlePasswordChange}
                            placeholder={'Password *'}
                        />

                        <Input
                            type="password"
                            value={confirmPassword}
                            onChange={this.handleConfirmPasswordChange}
                            placeholder={'Repeat the password *'}
                        />

                        <BlueButton
                            className="auth-submit-button"
                            height={36}
                            type={'submit'}
                            children={'Sign-Up'}
                        />

                        <div className="auth-form-link">
                            <Link to="/login" className="auth-form-link-button">
                                <SilverButton asDiv variant="ghost" height={36}>
                                    Sign-In
                                </SilverButton>
                            </Link>
                        </div>

                    </form>
                </div>
            </div>
        );
    }
}

Registration.propTypes = {
    token: PropTypes.string.isRequired,
    addNotification: PropTypes.func.isRequired,
};

export default withRouter(Registration);



// WEBPACK FOOTER //
// ./src/scenes/auth/Registration.jsx